import $ from 'jquery';
import popper from 'popper.js';
import 'bootstrap';
import 'owl.carousel';
import AOS from 'aos';
import ZoomIn from './ZooomIn'

window.$ = $;

if (module.hot) {
  module.hot.accept();
}

$('document').ready(()=>{

  //navbar 
  $(document).scroll(function () {
    var $nav = $(".pageNavbar");
    $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
  });

  //owl.carousel
  $('.owl-carousel').owlCarousel({
    loop:true,
    margin:10,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplaySpeed: 1000,
    dots: true,
    mouseDrag: false,
    responsive:{
        0:{
            items:1
        },
        768:{
            items:2

        },
        1000:{
            items:3
        }
    }
  })

  $('#moveToRight').on('click', ()=>{
    $('.owl-carousel').trigger('next.owl.carousel');
  })

  $('#moveToLeft').on('click', ()=>{
    $('.owl-carousel').trigger('prev.owl.carousel');
  })

  // smooth scroll 

  let smoothScroll = (event) => {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == event.currentTarget.pathname.replace(/^\//, '') 
      && 
      location.hostname == event.currentTarget.hostname
      ) {
      // Figure out element to scroll to
      var target = $(event.currentTarget.hash);
      target = target.length ? target : $('[name=' + event.currentTarget.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
            scrollTop: target.offset().top
            }, 1000, function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
                return false;
            } else {
                $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
            };
        });
      }
    }
  }

  $('.navBox-anchorsBox a, .navBox-logo a, .welcome a').on('click',(ev)=>{
    smoothScroll(ev)
    $('.hamburger__icon').removeClass('open');
    $('#submenu').removeClass('showMobileSubmenu')
  })

  //aos init
  AOS.init({
    duration: 800,
  });
})

document.addEventListener("DOMContentLoaded", function(event) {
  var elements = {
    burger: document.getElementsByClassName("hamburger")[0],
    icon: document.getElementsByClassName("hamburger__icon")[0],
    submenu: document.querySelector('#submenu')
  };

  elements.burger.onclick = function() {
    elements.icon.classList.toggle("open");
    
    if( elements.icon.classList.contains('open')) {
      submenu.classList.add('showMobileSubmenu')
    } else {
      submenu.classList.remove('showMobileSubmenu')
    }
  };

  setTimeout(()=>{
    new ZoomIn('.item img');
  },100)
});

